/* eslint-disable jsx-a11y/alt-text */
import "../styles/componentStyles/OrientationWarningComponent.scss";
export function OrientationWarningComponent() {
  return (
    <>
      <div id="orientationWarning">
        <img
          id="orientationWarningWrongWay"
          className="scaleUp"
          src="https://rpr-cdn.s3.us-west-1.amazonaws.com/webar-template/wrongWay.png"
        />
        <img
          id="orientationWarningRotate"
          className="scaleUp"
          src="https://rpr-cdn.s3.us-west-1.amazonaws.com/webar-template/rotatePhone.png"
        />
        <div id="orientationWarningInnerWrapper">
          <div id="arrowAndPhone" className="animateIn">
            <img
              id="orientationWarningArrow"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/webar-template/arrow.png"
            />
            <img
              id="orientationWarningPhone"
              src="https://rpr-cdn.s3.us-west-1.amazonaws.com/webar-template/phone.png"
            />
          </div>
          <img
            id="orientationWarningOk"
            className="animateIn"
            src="https://rpr-cdn.s3.us-west-1.amazonaws.com/webar-template/ok.png"
          />
        </div>
      </div>
    </>
  );
}
